import { Preview } from "./Preview";

export function PassiveContent({ networkName = "", password = "", onEdit }) {
  return (
    <div className={"py-6"}>
      <Preview networkName={networkName} password={password} onEdit={onEdit} />
    </div>
  );
}
